module.exports = __webpack_public_path__ + "img/2025-02.e438afae.jpg";